function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconHotelAnnexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13 12H9v2h4v-2zM9 16h4v2H9v-2z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 4H5v2h2v2H3v2h1v16H2v2h28v-2h-2v-8h1v-2h-4v-2h2v-2h-9v-2h1V8h-4V6h2V4zm8 22h1v-8h-8v8h1v-5h6v5zm-4 0h2v-3h-2v3zm-9 0h-2v-4h2v4zm2-6v6h2V10H6v16h2v-6h6zm9-6h-5v2h5v-2zM13 6v2H9V6h4z",
    fill: props.color
  }));
}

export default SvgIconHotelAnnexFilled;